import React, { useEffect } from "react";
import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import PlainTextarea from "@peracto/peracto-editor-ui/dist/PlainTextarea";
import Slider from "@peracto/peracto-editor-ui/dist/Slider";

import Checkbox from "@peracto/peracto-editor-ui/dist/Checkbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";
import dayjs from "dayjs";

const ReviewsForm = ({
    onChange,
    state: { reviews, heading = "What they say", selectedCardIndex },
}) => {
    const DEFAULT_CARD = {
        image: "https://placehold.co/200x200/EEE/31343C",
        content:
            "Velit quis incididunt consequat nisi reprehenderit adipisicing. Labore nostrud sunt minim aliqua aliqua sunt incididunt officia. Adipisicing sint non magna culpa non eiusmod proident esse dolore adipisicing ad irure. Occaecat cillum culpa officia reprehenderit irure.",
        customerName: "Customer Name",
        date: dayjs().format("YYYY-MM-DD"),
        isVerifiedBuyer: true,
        rating: 5,
    };

    useEffect(() => {
        return () => {
            onChange({ selectedCardIndex: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <TextInput
                label="Heading"
                onChange={(e) => {
                    onChange({ heading: e.target.value });
                }}
                value={heading}
            />
            {reviews?.length === 0 && (
                <>
                    <p>Click 'Add Review' to get started</p>
                    <hr />
                </>
            )}
            {selectedCardIndex !== null &&
                reviews &&
                reviews[selectedCardIndex] && (
                    <>
                        <PlainTextarea
                            label="Content"
                            onChange={(e) => {
                                const reviewsClone = [...reviews];
                                reviewsClone[selectedCardIndex].content =
                                    e.target.value;

                                onChange({
                                    reviews: reviewsClone,
                                });
                            }}
                            value={reviews[selectedCardIndex].content}
                        />

                        <Slider
                            label={`Rating: ${reviews[selectedCardIndex].rating}/5`}
                            min={1}
                            max={5}
                            step={1}
                            value={reviews[selectedCardIndex].rating}
                            onChange={(e) => {
                                const reviewsClone = [...reviews];
                                reviewsClone[selectedCardIndex].rating =
                                    e.target.value;

                                onChange({
                                    reviews: reviewsClone,
                                });
                            }}
                        />

                        <TextInput
                            label="Customer Name"
                            onChange={(e) => {
                                const reviewsClone = [...reviews];
                                reviewsClone[selectedCardIndex].customerName =
                                    e.target.value;

                                onChange({
                                    reviews: reviewsClone,
                                });
                            }}
                            value={reviews[selectedCardIndex].customerName}
                        />

                        <TextInput
                            label="Date"
                            type="date"
                            onChange={(e) => {
                                const reviewsClone = [...reviews];
                                reviewsClone[selectedCardIndex].date =
                                    e.target.value;

                                onChange({
                                    reviews: reviewsClone,
                                });
                            }}
                            value={reviews[selectedCardIndex].date}
                        />

                        <Checkbox
                            label="Verified Buyer"
                            checked={reviews[selectedCardIndex].isVerifiedBuyer}
                            onChange={(e) => {
                                const reviewsClone = [...reviews];
                                reviewsClone[
                                    selectedCardIndex
                                ].isVerifiedBuyer = e.target.checked;

                                onChange({
                                    reviews: reviewsClone,
                                });
                            }}
                        />

                        <button
                            className="btn btn-sm btn-danger w-100 mt-2"
                            onClick={(e) => {
                                const reviewsClone = [...reviews];

                                reviewsClone.splice(selectedCardIndex, 1);

                                onChange({
                                    reviews: reviewsClone,
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" />{" "}
                            Remove Review
                        </button>
                    </>
                )}

            <hr className="my-2" />

            <button
                className="btn btn-sm btn-secondary w-100"
                onClick={(e) => {
                    e.preventDefault();

                    const reviewsClone = [...reviews, DEFAULT_CARD];
                    onChange({
                        reviews: reviewsClone,
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add
                Review
            </button>
        </>
    );
};

export default ReviewsForm;
